import Flex from "@irati/ui/src/Flex"
import {useTheme} from "@irati/ui/src/global/useTheme"
import {IconTooltip} from "@irati/ui/src/Tooltip"
import {Body} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import React, {FC, ReactNode} from "react"
import styled from "styled-components"

interface Props {
  text: string
  children: ReactNode
  tooltip?: string
}

const FlexChild = styled.div`
  flex: 1;
`

const ViewOrderRow: FC<Props> = ({text, tooltip, children}) => {
  const theme = useTheme()
  return (
    <Flex justifyContent="space-between" marginBottom={2}>
      <FlexChild>
        <Flex alignItems="center">
          <Body small marginRight>
            <FormattedMessage id={text} />
          </Body>
          {tooltip && (
            <IconTooltip>
              <FormattedMessage id={tooltip} />
            </IconTooltip>
          )}
        </Flex>
      </FlexChild>
      <FlexChild>{children}</FlexChild>
    </Flex>
  )
}

export default ViewOrderRow
